import axios from '@/xaxios';

export const pruebas = (process.env.VUE_APP_GRAPHQL).includes('apidev')
// PROD
const X_FF_COMPANY_ispi = pruebas?'c44d153a-f18a-442d-bb8e-596488717399':'1ee49ec8-5d61-47b3-b15f-93fe1fffc917';
const X_FF_BRANCH_ispi = pruebas?'baebab7f-36e2-4d13-ba81-15da6366fd52':'5b22798a-16be-4d82-8a69-195ab52cda03';
const X_FF_API_KEY_ispi = pruebas?'afJLe10vlrHk_e8rwXMgG8n5hN5S8y8Yi6VS9X5NLegQY1izhfnx72sO955nsX_1ozVC2Ig4kcQujEypSnBcvb2df3UtHau3zPfVwhCzEbUPgw1iZicjgJsbBjcCnidA':'NhiAif0AAh8O6KDPpzo67CFAnXPQsAeSIfifFHLrVHmryOEggueWt2mQFHk3IZrUwBK6uUZLNkJT4MGB1SZ1WtmVXX7bV0ac701A0eELrv4xaO1R_V7SPWfsDQnEIHDL';

// TEST
// const X_FF_COMPANY_ispi = 'c44d153a-f18a-442d-bb8e-596488717399';
// const X_FF_BRANCH_ispi = 'baebab7f-36e2-4d13-ba81-15da6366fd52';
// const X_FF_API_KEY_ispi = 'afJLe10vlrHk_e8rwXMgG8n5hN5S8y8Yi6VS9X5NLegQY1izhfnx72sO955nsX_1ozVC2Ig4kcQujEypSnBcvb2df3UtHau3zPfVwhCzEbUPgw1iZicjgJsbBjcCnidA';

// TEST 
const X_FF_COMPANY_upi = pruebas?'bb647883-19b4-4578-a23d-51e4e2efc6e1':'d6f63e50-8cb0-47c4-a01c-5f4b4a0e8f7d';
const X_FF_BRANCH_upi = pruebas?'990cf3f2-277b-429f-b0c1-7a7d43892af9':'4ba13f33-2ba8-403f-b050-c1a01945ab2b';
const X_FF_API_KEY_upi = pruebas?'B81zMrwDv3o9I_aWDLrgqf2ygAQWDn2CruMLQU0rkrf3ZLSyNr1L8XFsdndPvH9QiEshx1JJQZicJhrSWWetI6oSb3BndvAgkfO4nuJqweEzs0h6Z1ylKPO7YCRCF9PT':'oDn4ZhupuyywuiTGxFZ7P_HSI12L3tq4TnpobBsPlvpmjfnwdyc85aGBgytQukV70fnBNVhZaXoZLwAhxcJVZhXiEguY027C0g4m9bVUZzMZtOPUvjUGHi_I9PE1NYwv';

import { getUserData,setAccessToken } from '@/accessToken.js'  
export const FACTURAS_BASE_PATH = 'https://pagosdev.upi.edu.pa'
// export const FACTURAS_BASE_PATH = 'http://localhost:8013'


export const getApiFactura = (unidadid, sedeid) => {
  if(unidadid == 14){
    return {
      X_FF_COMPANY: X_FF_COMPANY_ispi,
      X_FF_BRANCH: X_FF_BRANCH_ispi,
      X_FF_API_KEY: X_FF_API_KEY_ispi
    }
  }else if(unidadid == 15){
    // const sedesUpiConRucIspi = [86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 102, 103, 104, 105, 106, 108, 109, 115, 116, 117, 118, 119, 120, 121, 122, 123];
    const sedesUpiConRucIspi = [82];
    const existe = sedesUpiConRucIspi.includes(sedeid);
    if(!existe){
      return {
        X_FF_COMPANY: X_FF_COMPANY_ispi,
        X_FF_BRANCH: X_FF_BRANCH_ispi,
        X_FF_API_KEY: X_FF_API_KEY_ispi
      }
    }

    return {
      X_FF_COMPANY: X_FF_COMPANY_upi,
      X_FF_BRANCH: X_FF_BRANCH_upi,
      X_FF_API_KEY: X_FF_API_KEY_upi
    }
  }
}

export const apifacturar = async (input, unidad, sede) => {
  

  const apisdata = getApiFactura(unidad, sede);
  const myHeaders = new Headers();
  myHeaders.append('X-FF-Company', apisdata.X_FF_COMPANY);
  myHeaders.append('X-FF-Branch', apisdata.X_FF_BRANCH);
  myHeaders.append('X-FF-API-Key', apisdata.X_FF_API_KEY);
  myHeaders.append('Content-Type', 'application/json');

  // let apidev = process.env.VUE_APP_GRAPHQL;
  // let TEST = apidev.includes("apidev")
  let url = FACTURAS_BASE_PATH+'/proxy2/https://api.facturafacil.com.pa/api/pac/reception_fe/detailed/'
  if(pruebas) url = FACTURAS_BASE_PATH+'/proxy/api/pac/reception_fe/detailed/'

  return await axios
    .post(
      url,
      input, // 👈 body
      {
        headers: {
          'X-FF-Company': apisdata.X_FF_COMPANY,
          'X-FF-Branch': apisdata.X_FF_BRANCH,
          'X-FF-API-Key': apisdata.X_FF_API_KEY,
        },
      },
    )
    .then(({ data }) => data)
    .catch((e) => e);
};

export const apiviewfactura = async (cufe, uuid) => {
  // let apidev = process.env.VUE_APP_GRAPHQL;
  // let TEST = apidev.includes("apidev")
  let url = `${FACTURAS_BASE_PATH}/proxy2/https://api.facturafacil.com.pa/api/pac/reception_fe/${uuid}/download_cafe/?cufe=${cufe}`
  if(pruebas) url = `${FACTURAS_BASE_PATH}/proxy/api/pac/reception_fe/${uuid}/download_cafe/?cufe=${cufe}`

  const response = await fetch(url);
  if (!response.ok) {
    return null
  }
  const blob = await response.blob();
  return blob
};

export const guardarFacturaNulRecibo = async (xvue,factura,recibo, ruc) => {
  const ex = getUserData(); 
  if( ex ){  
    const u = JSON.parse(ex);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const raw = JSON.stringify({ username: u.user, password: u.clave });
    const requestOptions = { method: 'POST', headers: myHeaders, body: raw };
    const rr = await fetch(process.env.VUE_APP_AUTH_POST, requestOptions).then((response) => response.json()).then((data)=>data).catch(e=>e)
    if(rr && rr.ok){
      const token = rr.accessToken 
      setAccessToken(token)
    }
  } 

  var config = {
    method: 'put',
    url: `${process.env.VUE_APP_API_REST}/api/v1/esam/recibo/${recibo.id}/factura`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      facturaID: parseInt(factura.did),
      numeroFactura: parseInt(factura.document_number),
      ruc: ruc,
      cufe: factura.cufe,
      uuid: factura.document_uuid, 
    },
  };

  saveBackup(config.data,recibo.id)

  await axios
    .request(config)
    .then(function (response) {
      let data = response.data;
      window.console.log('guardarFacturaNulRecibo::: ', data);
      xvue.$emit('reloadRecibos', true);
      let t = 'Factura enlazada con recibo.'
      if(data && data.data) t = data.data
      xvue.$root.$notify.show(t, {color:'green',x: 'left',y:'top'});
    })
    .catch(function (error) {
      let data = error.response ? error.response.data: error;
      window.console.log(data);
      if(data && data.data){
        xvue.$root.$notify.show('Error al asignar factura al recibo: '+data.data, {color:'red',x: 'left',y:'top'});
      }else{
        const t = 'Error al asignar la factura al recibo'
        xvue.$root.$notify.show(t, {color:'red',x: 'left',y:'top'}); 
      }
    });
};

export const anularFacturaNulRecibo = async (recibo) => { 
  var config = {
    method: 'put',
    url: `${process.env.VUE_APP_API_REST}/api/v1/esam/recibo/${recibo.id}/factura`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      facturaID: null,
      numeroFactura: null,
      ruc: null,
      cufe: null,
      uuid: null, 
    },
  }; 

  const res = await axios.request(config).then(d=>d).catch(e=>e); 
  // 
  
  var configrec = {
    method: 'put',
    url: `${process.env.VUE_APP_API_REST}/api/v1/esam/recibo/addfactura`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      recibo_id: recibo.id,
      factura_id: null,
      numero_factura: null,
      nit: null,
    },
  };
  await axios.request(configrec).then(d=>d).catch(e=>e);

  

  return res
};

// upi_pagos no es relevante solo guarda una copia de la vinculacion
// es como un respaldo
const saveBackup = (data, reciboid) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query: "mutation vincular_factura_recibo($input:VinculoRecibo!){\n  vincular_factura_recibo(input:$input)\n}",
    variables: {"input":{"recibo_id":reciboid,"factura_id":data.facturaID,"numero_factura":data.numeroFactura,"ruc":data.ruc,"cufe":data.cufe,"uuid":data.uuid}}
  })
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql, 
  };

  fetch(FACTURAS_BASE_PATH+"/query", requestOptions)
    .then((response) => response.json())
    .then((result) => window.console.log(result))
    .catch((error) => window.console.error(error));
}

export const getBackup = async (reciboid) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query: "query facturas_vinculadas($recibo_id:ID!){ facturas_vinculadas(recibo_id:$recibo_id){ factura_id numero_factura cufe ruc uuid fecha_registro } }",
    variables: {"recibo_id":reciboid}
  })
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow"
  };

  return await fetch(FACTURAS_BASE_PATH+"/query", requestOptions)
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => error);
}

export const get_factura_by_cufe = async (cufe,unidad_negocio,sede) => { 
  const myHeaders = new Headers();
  const apisdata = getApiFactura(unidad_negocio, sede);
  myHeaders.append('X-FF-Company', apisdata.X_FF_COMPANY);
  myHeaders.append('X-FF-Branch', apisdata.X_FF_BRANCH);
  myHeaders.append('X-FF-API-Key', apisdata.X_FF_API_KEY);
  myHeaders.append('Content-Type', 'application/json');

  // let apidev = process.env.VUE_APP_GRAPHQL;
  // let TEST = apidev.includes("apide-vvvvvvv")
  let url = `${FACTURAS_BASE_PATH}/proxy2/https://api.facturafacil.com.pa/api/pac/reception_fe/find_by_cufe_or_id/?cufe_or_id=${cufe}`
  if(pruebas) url = `${FACTURAS_BASE_PATH}/proxy/api/pac/reception_fe/find_by_cufe_or_id/?cufe_or_id=${cufe}`

  return await axios
    .get(
      url,
      {
        headers: {
          'X-FF-Company': apisdata.X_FF_COMPANY,
          'X-FF-Branch': apisdata.X_FF_BRANCH,
          'X-FF-API-Key': apisdata.X_FF_API_KEY,
        },
      },
    )
    .then(({ data }) => data)
    .catch((e) => e);
};